var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-provider", {
    ref: "validationProvider",
    staticClass: "_eui-form_textruta_validation-provider",
    attrs: {
      tag: "div",
      mode: "eagerMedBlurOchDebounce",
      rules: _vm.vpValidationRules
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var valid = ref.valid
          var errors = ref.errors
          var failedRules = ref.failedRules
          var flags = ref.flags
          return [
            _c(
              "div",
              {
                staticClass: "_eui-form_textruta",
                class: [
                  _vm.vpClass,
                  {
                    "-obligatorisk":
                      _vm.arRequired && !_vm.vpIndikeraInteObligatorisk,
                    "-losen": _vm.arLosen && !_vm.vpReadOnly,
                    "-readonly": _vm.vpReadOnly,
                    "-osynlig": _vm.skaVaraOsynlig,
                    "-invalid": flags.validated && !valid
                  }
                ],
                style: _vm.vpStyle,
                attrs: { disabled: _vm.skaVaraInaktiverad }
              },
              [
                _c("label", {
                  staticClass: "_eui-form_textruta_etikett",
                  class: {
                    fore: true,
                    "-readonly": _vm.vpReadOnly
                  },
                  style: { "max-width": _vm.vpEtikettbreddMedEnhet },
                  attrs: { for: _vm.uniktId, title: _vm.vpTooltip },
                  domProps: { innerHTML: _vm._s(_vm.vpEtikett + ":") }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "_eui-form_textruta_rutyta",
                    style: { "max-width": _vm.vpRutbreddMedEnhet }
                  },
                  [
                    _vm.inputType === "checkbox"
                      ? _c(
                          "input",
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.innerValue,
                                  expression: "innerValue"
                                }
                              ],
                              ref: "inputelementet",
                              class: {
                                "-readonly": _vm.vpReadOnly
                              },
                              attrs: {
                                id: _vm.uniktId,
                                name: _vm.uniktId + "-name",
                                placeholder:
                                  !_vm.vpReadOnly && _vm.vpPlaceholder,
                                autofocus: _vm.vpAutofocus,
                                spellcheck: "false",
                                disabled:
                                  _vm.skaVaraInaktiverad || _vm.vpReadOnly,
                                type: "checkbox"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.innerValue)
                                  ? _vm._i(_vm.innerValue, null) > -1
                                  : _vm.innerValue
                              },
                              on: {
                                keydown: [
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.onEnterTryckt()
                                  },
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "esc",
                                        27,
                                        $event.key,
                                        ["Esc", "Escape"]
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.onEscTryckt()
                                  }
                                ],
                                change: function($event) {
                                  var $$a = _vm.innerValue,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.innerValue = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.innerValue = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.innerValue = $$c
                                  }
                                }
                              }
                            },
                            "input",
                            _vm.$attrs,
                            false
                          )
                        )
                      : _vm.inputType === "radio"
                      ? _c(
                          "input",
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.innerValue,
                                  expression: "innerValue"
                                }
                              ],
                              ref: "inputelementet",
                              class: {
                                "-readonly": _vm.vpReadOnly
                              },
                              attrs: {
                                id: _vm.uniktId,
                                name: _vm.uniktId + "-name",
                                placeholder:
                                  !_vm.vpReadOnly && _vm.vpPlaceholder,
                                autofocus: _vm.vpAutofocus,
                                spellcheck: "false",
                                disabled:
                                  _vm.skaVaraInaktiverad || _vm.vpReadOnly,
                                type: "radio"
                              },
                              domProps: {
                                checked: _vm._q(_vm.innerValue, null)
                              },
                              on: {
                                keydown: [
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.onEnterTryckt()
                                  },
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "esc",
                                        27,
                                        $event.key,
                                        ["Esc", "Escape"]
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.onEscTryckt()
                                  }
                                ],
                                change: function($event) {
                                  _vm.innerValue = null
                                }
                              }
                            },
                            "input",
                            _vm.$attrs,
                            false
                          )
                        )
                      : _c(
                          "input",
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.innerValue,
                                  expression: "innerValue"
                                }
                              ],
                              ref: "inputelementet",
                              class: {
                                "-readonly": _vm.vpReadOnly
                              },
                              attrs: {
                                id: _vm.uniktId,
                                name: _vm.uniktId + "-name",
                                placeholder:
                                  !_vm.vpReadOnly && _vm.vpPlaceholder,
                                autofocus: _vm.vpAutofocus,
                                spellcheck: "false",
                                disabled:
                                  _vm.skaVaraInaktiverad || _vm.vpReadOnly,
                                type: _vm.inputType
                              },
                              domProps: { value: _vm.innerValue },
                              on: {
                                keydown: [
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.onEnterTryckt()
                                  },
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "esc",
                                        27,
                                        $event.key,
                                        ["Esc", "Escape"]
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.onEscTryckt()
                                  }
                                ],
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.innerValue = $event.target.value
                                }
                              }
                            },
                            "input",
                            _vm.$attrs,
                            false
                          )
                        ),
                    _vm._v(" "),
                    _vm.arLosen
                      ? _c(
                          "eui-knapp",
                          {
                            staticStyle: {
                              width: "1.6em",
                              height: "1.6em",
                              padding: "0.2em",
                              "border-radius": "100%",
                              position: "absolute",
                              top: "0",
                              right: "-1.6em",
                              "line-height": "0"
                            },
                            attrs: { "vp-css-modifier-class": "-transparent" },
                            on: {
                              tryckt: function($event) {
                                return _vm.onTogglaSynlighet()
                              }
                            }
                          },
                          [
                            _c("eui-modifierad-svg", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.losenArSynligt,
                                  expression: "losenArSynligt"
                                }
                              ],
                              attrs: { "vp-ikon": "doljLosen" }
                            }),
                            _vm._v(" "),
                            _c("eui-modifierad-svg", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.losenArSynligt,
                                  expression: "!losenArSynligt"
                                }
                              ],
                              attrs: { "vp-ikon": "visaLosen" }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "_eui-form_textruta_feltext" }, [
                      _c("div", {
                        staticClass: "ellipsis",
                        domProps: { innerHTML: _vm._s(errors[0]) }
                      })
                    ])
                  ],
                  1
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }